import {NavigationDropdown} from '../components'

const taxonomy = {
	billing_infos: {to: '/billing/billing_infos'},
	unpaid_invoices: {to: '/billing/unpaid_invoices'},
	perform_invoicing: {enableRole: 'admin', modalLink: '/billing/perform_invoicing'},
}

export const Billing = () => <NavigationDropdown name="billing" taxonomy={taxonomy} />
